import { Badge } from "reactstrap";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import { getStatusBadge } from "@src/utility/helpers/utils";
import upperCase from "lodash/upperCase";

export const decoColumns = () => {
    return [
        {
            name : "Name",
            width: "250px",
            cell : row => (
                <LongNameFormatter
                    content={row.name}
                    className=""
                    id={`name-${row._id}`}
                    max={30}/>
            )
        },
        {
            name : "Email",
            width: "250px",
            cell : row => <span>{row.email}</span>
        },
        {
            name : "Role",
            width: "150px",
            cell : (row) => {
                const statusBadge = getStatusBadge(row.role);
                return (
                    <Badge color={statusBadge?.color}>
                        {upperCase(statusBadge?.title)}
                    </Badge>
                );
            }
        },        
        {
            name : "Phone",
            width: "200px",
            cell : row => { return row.phone; }
        },
        {
            name : "Company Name",
            width: "250px",
            cell : row => (
                //add this comment because it will need in future
                // <Link className="text-primary" to={`/dashboard/companies/${row.org?.org_id}`}>
                row.org?.org_name
                // </Link>
            )
        },
        {
            name : "Skype ID",
            width: "200px",
            cell : row => <span>{row.skype_id || "N/A"}</span>
        }
    ];
};
